import React from 'react';
import { Table } from 'semantic-ui-react';
import { firstErrorMessage } from '@/utils/errors';
import { states } from '@/constants/lifecycle';
import TableHeader from '@/components/table/TableHeader';
import CollectionDatasetsTableColumns from '../containers/CollectionDatasetsTableColumns';

const CollectionDatasetsTableHeader = ({
  category,
  children,
  code,
  columns,
  hideColumns,
  datasets,
  loaderButton,
  readErrors,
  readStatus,
}) => (
  <Table.Header fullWidth>
    <TableHeader
      isLoading={readStatus === states.PENDING}
      error={firstErrorMessage(readErrors)}
      numberOfColumns={columns.length}
      loaderButton={loaderButton}
    >
      {children}
    </TableHeader>
    {!hideColumns
    && <CollectionDatasetsTableColumns category={category} code={code} items={datasets} columns={columns} />}
  </Table.Header>
);

export default CollectionDatasetsTableHeader;
